<div *ngIf="isAlertShown" class="alert-wrapper">
    <div class="alert alert-{{ type }}">{{ message }}</div>
</div>
